import { ModalMaker } from './modalMaker'

const PROP_NAME_PRIV = 'faker__modal'
const PROP_NAME = '$customModal'

const Modal = (Vue, options) => {
  Vue.mixin({
    beforeCreate() {
      this[PROP_NAME_PRIV] = new ModalMaker(this, options) 
    }
  })

  if (!Object.prototype.hasOwnProperty.call(Vue.prototype, PROP_NAME)) {
    Object.defineProperty(
      Vue.prototype,
      PROP_NAME, 
      {
        get() {
          return this[PROP_NAME_PRIV]
        }
      }
    )
  }
}

export const installFactory = ({ plugin } = {}) => {
  const install = (Vue, config = {}) => {
    if (install.installed) {
      return
    }
    install.installed = true
    Vue.use(plugin, config)
  }

  install.installed = false

  return install
}

export const pluginFactory = (plugin) => ({
  install: installFactory({ plugin })
})

export default installFactory({ plugin: Modal })
// export default Modal
